import { getShellLogger } from '../../common/logger'
import { getEventBus } from '../namespaces/event-bus'
import { NotificationChannelEvents, NotificationChannelNamespace } from '../notification-channel'
import type { NotificationChannelEvent, RTCError } from '../notification-channel/models'
import type { NotificationChannelHandlerParams, NotificationHandler } from '@goto/shell-notification-channel'
import { NotificationHandlerEventType, WebSocketNotificationHandler } from '@goto/shell-notification-channel'

export class ShellWebSocketNotificationHandlerFactory {
  private readonly notificationNamespace = getEventBus().register(
    NotificationChannelNamespace,
    NotificationChannelEvents,
  )

  public create = (params: NotificationChannelHandlerParams): NotificationHandler => {
    const handler = new WebSocketNotificationHandler(params)
    this.removeListeners(params)
    this.addListeners(params)
    return handler
  }

  private addListeners = (params: NotificationChannelHandlerParams): void => {
    params.emitter.addListener(NotificationHandlerEventType.OPEN, this.handleHandlerOpenEvent)
    params.emitter.addListener(NotificationHandlerEventType.CLOSE, this.handleHandlerCloseEvent)
    params.emitter.addListener(NotificationHandlerEventType.MESSAGE, this.handleHandlerMessageEvent)
    params.emitter.addListener(NotificationHandlerEventType.ERROR, this.handleHandlerErrorEvent)
  }

  private removeListeners = (params: NotificationChannelHandlerParams): void => {
    params.emitter.removeListener(NotificationHandlerEventType.OPEN, this.handleHandlerOpenEvent)
    params.emitter.removeListener(NotificationHandlerEventType.CLOSE, this.handleHandlerCloseEvent)
    params.emitter.removeListener(NotificationHandlerEventType.MESSAGE, this.handleHandlerMessageEvent)
    params.emitter.removeListener(NotificationHandlerEventType.ERROR, this.handleHandlerErrorEvent)
  }

  private handleHandlerOpenEvent = (): void => {
    this.notificationNamespace.emit.connected()
  }

  private handleHandlerCloseEvent = (error: RTCError): void => {
    this.notificationNamespace.emit.disconnected(error)
    getShellLogger().error(error)
  }

  private handleHandlerMessageEvent = (event: NotificationChannelEvent): void => {
    this.notificationNamespace.emit.message(event)
  }

  private handleHandlerErrorEvent = (error: RTCError): void => {
    getShellLogger().error('WebSocket:Error', error)
    this.notificationNamespace.emit.error(error)
  }
}
